
import { Vue, Component } from 'vue-property-decorator';
import NewsList from '@/components/next/NewsList.vue';
import { rule } from '../api/rule';
@Component({
  components: {
    NewsList,
  },
})
export default class News extends Vue {
  get classId() {
    if (process.env.VUE_APP_ENV_NAME === 'production') {
      return 9009;
    } else {
      return 6;
    }
  }
}
